import { $win, $body } from "./globals";
import isMobile from "./isMobile";

$win.on("load", function() {
  if (isMobile.any()) {
    $body.addClass("is-mobile");
  }
});
